import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import "./custom.css";
import "./responsive.css";
import Router from './router/NavRouter';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  
  useEffect(() => {
    if (!sessionStorage.getItem("first_landing_url")) {
      sessionStorage.setItem("first_landing_url", window.location.href);
    }
  }, []);


  const NormalizeTrailingSlash = () => {
  useEffect(() => {
      if (location.pathname !== '/' && location.pathname.endsWith('/')) {
        window.history.replaceState(
          null,
          '',
          location.pathname.slice(0, -1) + location.search + location.hash
        );
      }
    }, []);

    return null;
  };

  return (
    <div className="App">
      <NormalizeTrailingSlash/>
      <Router />
      <ToastContainer/>
    </div>
  );
}

export default App;
